/**
 * Sala de ventas de `/nuestra-tienda`, en cuatro tarjetas: donde, cuando,
 * como contactar y donde estacionar. Todo sale de `SITIO`.
 */
import { SITIO } from '../../configuracion/sitio';
import { enlaceTelefono } from '../../utilidades/telefono';
import { TarjetaIcono } from './TarjetaIcono';

export interface VisitaTiendaProps {
  enlaceMaps: string;
}

export function VisitaTienda({ enlaceMaps }: VisitaTiendaProps) {
  return (
    <section className="tienda-seccion" aria-labelledby="sala-de-ventas">
      <div className="tienda-seccion-cab">
        <p className="presentacion-antetitulo">Sala de ventas</p>
        <h2 id="sala-de-ventas">Visítanos en San Diego</h2>
      </div>
      <ul className="tienda-tarjetas">
        <TarjetaIcono icono="ubicacion" titulo="Dirección">
          <p>
            {SITIO.direccion.calle}, {SITIO.direccion.comuna}
          </p>
          <p className="nota">A pasos del Teatro Caupolicán</p>
          <a href={enlaceMaps} target="_blank" rel="noopener noreferrer">
            Cómo llegar (Google Maps)
          </a>
        </TarjetaIcono>
        <TarjetaIcono icono="reloj" titulo="Horario">
          {SITIO.horario.split(' · ').map((tramo) => (
            <p key={tramo}>{tramo}</p>
          ))}
        </TarjetaIcono>
        <TarjetaIcono icono="telefono" titulo="Contacto">
          <a href={enlaceTelefono(SITIO.telefono)}>{SITIO.telefono}</a>
          <a href={`mailto:${SITIO.email}`}>{SITIO.email}</a>
        </TarjetaIcono>
        <TarjetaIcono icono="estacionamiento" titulo="Estacionamiento gratis">
          <p>Para clientes, por calle Copiapó, esquina Lincoyán Berríos.</p>
        </TarjetaIcono>
      </ul>
    </section>
  );
}
